// extracted by mini-css-extract-plugin
export var container = "Hero-module--container--s6CMy";
export var verticalCenter = "Hero-module--verticalCenter--3mZuy";
export var arrowWrapper = "Hero-module--arrowWrapper--XGa1h";
export var UpAndDown = "Hero-module--UpAndDown--2tAy8";
export var waveWrapper = "Hero-module--waveWrapper--38sV7";
export var title = "Hero-module--title--1WvPu";
export var subtitle = "Hero-module--subtitle--I2CyT";